@if (imageUrl) {
    <div class="fixed inset-0 bg-black/80 flex items-center justify-center p-4 sm:p-10 z-[1060]"
         (click)="onBackdropClick($event)">

        <div class="relative flex items-center justify-center w-full h-full select-none overflow-hidden"
             [style.cursor]="zoomLevel > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'"
             (wheel)="onWheel($event)"
             (mousedown)="onDragStart($event)"
             (mousemove)="onDragMove($event)"
             (mouseup)="onDragEnd()"
             (mouseleave)="onDragEnd()"
             (click)="onContentClick($event)">

            <button class="btn-card-icon absolute top-3 right-3 z-[3]"
                    (click)="close()"
                    type="button"
                    [attr.aria-label]="'image.preview.close' | translate">
                <app-icon icon="line-md:close" size="lg" />
            </button>

            <img [src]="imageUrl"
                 [alt]="imageName"
                 class="max-w-full max-h-full rounded-box object-contain pointer-events-none"
                 [style.transform]="zoomTransform"
                 [style.transition]="isDragging ? 'none' : 'transform 0.15s ease-out'">

            <!-- Image name -->
            <div class="absolute bottom-12 left-1/2 -translate-x-1/2 bg-neutral text-neutral-content px-3 py-2 rounded-full text-sm whitespace-nowrap border border-base-300 z-[3] pointer-events-none">
                {{ imageName }}
            </div>

            <!-- Zoom controls -->
            <div class="absolute bottom-3 right-3 flex items-center gap-1 z-[3]">
                <button type="button"
                        class="btn-card-icon"
                        [disabled]="zoomLevel <= 1"
                        (click)="zoomOut()">
                    <app-icon icon="ph:magnifying-glass-minus" size="sm"/>
                </button>
                @if (zoomLevel > 1) {
                    <button type="button"
                            class="btn btn-ghost btn-sm bg-base-100 font-mono text-xs px-2"
                            (click)="resetZoom()">
                        {{ zoomLabel }}
                    </button>
                }
                <button type="button"
                        class="btn-card-icon"
                        [disabled]="zoomLevel >= 4"
                        (click)="zoomIn()">
                    <app-icon icon="ph:magnifying-glass-plus" size="sm"/>
                </button>
            </div>

        </div>
    </div>
}
